import { isAxiosError } from "axios";
import type { QueryError } from "./types";

export const normalizeError = (error: unknown): QueryError => {
    if (isAxiosError(error)) {
        return {
            message: error.response?.data?.message ?? error.message ?? "Unknown error",
            statusCode: error.response?.status,
            cause: error,
            details: error.response?.data,
        };
    }

    if (error instanceof Error) {
        return {
            message: error.message,
            cause: error.cause,
        };
    }

    return {
        message: typeof error === "string" ? error : "Unknown error",
        details: error,
    };
};

